import { IQueryOptions, IQueryKeyValue } from '../../models/commonTypes';

export default function pivotQueryCollection(
    queries: Array<IQueryOptions>
): IQueryKeyValue {
    return queries.reduce((obj, item) => {
        obj[item.queryId] = item;
        return obj;
    }, {});
}



// WEBPACK FOOTER //
// ./src/utils/query/pivotQueryCollection.ts